import { FC } from 'react'
import InfoOutline from '@rsuite/icons/InfoOutline'
import { Slider } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

import TakeRateInfoPopover from './TakeRateInfoPopover'
import { Product, ProductQuantity } from '../../utils/types/Product'
import useProductTakeRate from '../../services/useProductTakeRate'
import { getTotalProductQuantity } from '../../lib/product'
import SafeTranslate from '../common/SafeTranslate'

import styles from '../../styles/ProductDiscountBar.module.less'

interface ProductDiscountBarProps {
  product: Product
  productQuantity: ProductQuantity[]
}

const ProductDiscountBar: FC<ProductDiscountBarProps> = ({ product, productQuantity }) => {
  const { t } = useTranslation('products')
  const takeRate = useProductTakeRate(product, productQuantity) * 100
  const selectedQuantity = getTotalProductQuantity(productQuantity)

  const sppDiscountSliderAndTableV3FeatureFlag = useFeatureIsOn('spp-discount-slider-and-table-v3')

  // 700 so that when 7% is reached it will appear 100% on progress bar
  const progressBarPercentage = selectedQuantity > 0 ? 700 / takeRate : 0

  const renderTooltip = () => <p className={styles.tooltip}>{t('Watch your prices decrease in real time as you add products to your cart or as your team spends more at Droppe')}</p>

  if (!sppDiscountSliderAndTableV3FeatureFlag) {
    return null
  }

  return (
    <>
      <p className={styles['discount-text']}>
        {selectedQuantity > 0
          ? (
            <SafeTranslate
              i18nKey={t('Discount calculated for {{selectedQuantity}} pcs add more to save more', { selectedQuantity })}
              components={{ b: <b /> }}
            />
          ) : (
            <SafeTranslate
              i18nKey={t('See your personal discount by adjusting the quantity')}
              components={{ b: <b /> }}
            />
          )}
      </p>
      <TakeRateInfoPopover>
        <InfoOutline className={styles['info-icon']} />
      </TakeRateInfoPopover>
      <div>
        <Slider
          progress
          value={progressBarPercentage}
          readOnly
          className="padding-zero margin-top-spacer-half margin-bottom-spacer-double margin-top-spacer"
          renderTooltip={renderTooltip}
          barClassName={styles.bar}
          handleClassName={`${styles.handle} ${selectedQuantity > 0 ? '' : styles.hide}`}
        />
      </div>
    </>
  )
}

export default ProductDiscountBar
